// @flow
import React, { Component } from 'react';
import NavTabs from '../../components/NavTabs';
import { TabNavLink, SpacerTab } from '../../components/TabStyles';
import { MerchantsNavHeaderDiv } from './MerchantsStyles';
import { Default } from '../../components/Responsive';

type Props = {
  path: string
};

export default class HeaderBlock extends Component<Props> {
  render() {
    return (
      <>
        <MerchantsNavHeaderDiv>
          <NavTabs>
            <TabNavLink
              exact
              activeShow={
                !this.props.path.startsWith('transactions', 11) &&
                !this.props.path.startsWith('registrations', 11)
              }
              to="/merchants"
            >
              <Default>Direct</Default> Merchants
            </TabNavLink>
            <TabNavLink to="/merchants/transactions">
              <Default>Direct Merchant </Default>Transactions
            </TabNavLink>
            <TabNavLink to="/merchants/registrations">
              Refer <Default>Direct</Default> Merchants
            </TabNavLink>
            <SpacerTab tablet />
          </NavTabs>
        </MerchantsNavHeaderDiv>
      </>
    );
  }
}
